import api from '../api/axiosInstance'; // Asumiendo configuración centralizada de Axios

export const getMiUsuario = async (email) => {
    const response = await api.get(`/mi-usuario?email=${encodeURIComponent(email)}`);
    return response.data;
};

export const editarMiUsuario = async (usuario) => {
    const response = await api.post('/mi-usuario/editar', usuario);
    return response.data;
};
